import { offersType, planType } from '@shared/helpers/function.helpers';
import { Offers } from '@dgx-pr-spa/shared/util';
import { DataLayer } from '@dgx-pr-spa/shared/util';
import { ReplacementOffer } from '@dgx-pr-spa/shared/util';

export class GAProductDetailsCommon {
  constructor(
    public readonly offers: Offers,
    public readonly selected: ReplacementOffer,
    public readonly totalCostReplacement: number
  ) {}

  get gaCommonData(): DataLayer {
    const offers = this.offers;
    const currentItem = offers?.current_item;
    const customerType = 'G';
    const currentPlan = offers?.current_plan;
    const contact = offers?.contact_details;
    const offer = offers?.offer;
    const selected = this.selected;

    const productName =
      currentItem?.make && currentItem?.appliance_category
        ? `${currentItem.make} ${currentItem.appliance_category}`
        : undefined;

    const productNameOffer = `${selected?.make} ${selected?.appliance_category}`;

    const PRGroup = 'aws';

    const dataLayer: DataLayer = {
      pagename: 'product-replacement-product-details',
      category: 'product-replacement',
      genericpagename: 'product-replacement-checkout',
      OfferType: offersType(offers)?.toString(),
      planNumber: currentPlan?.plan_number,
      PlanType: planType(currentPlan),
      customerID: contact?.person_gid,
      JobReferenceNumber: currentPlan?.reference_number,
      productName,
      productModel: currentItem?.model,
      AccountBrand: currentItem?.make,
      Manufacturer: currentItem?.make,
      productNameOffer,
      productModelOffer: selected?.model,
      AccountBrandOffer: selected?.make,
      ManufacturerOffer: selected?.make,
      upgrade: selected?.upgrade_fee,
      outstandingMonthlyPayments: offer?.outstanding_dd_count,
      remainingPayment: offer?.outstanding_dd_amount,
      customerType,
      paymentOffer: 'MPM',
      PRGroup,
      rrp: selected?.rrp,
    };

    return dataLayer;
  }
}
export class GAProductDetailsPageLoad extends GAProductDetailsCommon {
  constructor(
    public readonly offers: Offers,
    public readonly selected: ReplacementOffer,
    public readonly totalCostReplacement: number
  ) {
    super(offers, selected, totalCostReplacement);
  }

  get gaData(): DataLayer {
    const dataLayer: DataLayer = {
      ...this.gaCommonData,
      event: 'PRAWS',
      eventPR: 'product-replacement-product-details',
    };

    return dataLayer;
  }
}

export class GAProductDetailsThumbnailClick extends GAProductDetailsCommon {
  constructor(
    public readonly offers: Offers,
    public readonly selected: ReplacementOffer,
    public readonly totalCostReplacement: number
  ) {
    super(offers, selected, totalCostReplacement);
  }

  get gaData(): DataLayer {
    const dataLayer: DataLayer = {
      ...this.gaCommonData,
      event: 'PRGenericGAEvent',
      eventPR: 'ViewMoreImages',
    };

    return dataLayer;
  }
}

export class GAProductDetailsContinueCTAClick extends GAProductDetailsCommon {
  constructor(
    public readonly offers: Offers,
    public readonly selected: ReplacementOffer,
    public readonly totalCostReplacement: number
  ) {
    super(offers, selected, totalCostReplacement);
  }
  get gaData(): DataLayer {
    const offers = this.offers;

    const dataLayer: DataLayer = {
      ...this.gaCommonData,
      event: 'PRGenericGAEvent',
      eventPR: 'Continue',
      imageloaded: 'Yes',
      Category: 'Product Replacement',
      Action: 'Continue',
      Label: offers?.current_plan?.plan_number,
    };

    return dataLayer;
  }
}

export class GADeliveryUnavailableModal extends GAProductDetailsCommon {
  constructor(
    public readonly offers: Offers,
    public readonly selected: ReplacementOffer,
    public readonly totalCostReplacement: number
  ) {
    super(offers, selected, totalCostReplacement);
  }

  get gaData(): DataLayer {
    const currentPlan = this.offers?.current_plan;

    const dataLayer: DataLayer = {
      ...this.gaCommonData,
      event: 'PRAWS',
      eventPR: 'PR-unavailable-product',
      pagename: 'product-replacement-unavailable-product',
      genericpagename: 'product-replacement-checkout',
      category: 'product-replacement',
      planNumber: currentPlan?.plan_number,
      applianceName: this.selected?.appliance_category,
      eventAction: 'PR-unavailable-product',
      eventCategory: 'Product Replacement',
      eventLabel: currentPlan?.plan_number,
    };

    return dataLayer;
  }
}

export class GADeliveryApiErrorModal extends GAProductDetailsCommon {
  constructor(
    public readonly offers: Offers,
    public readonly selected: ReplacementOffer,
    public readonly totalCostReplacement: number
  ) {
    super(offers, selected, totalCostReplacement);
  }

  get gaData(): DataLayer {
    const currentPlan = this.offers?.current_plan;

    const dataLayer: DataLayer = {
      ...this.gaCommonData,
      event: 'PRAWS',
      eventPR: 'PR-unavailable-Api-failure',
      pagename: 'product-replacement-unavailable-product',
      genericpagename: 'product-replacement-checkout',
      category: 'product-replacement',
      planNumber: currentPlan?.plan_number,
      applianceName: this.selected?.appliance_category,
      eventAction: 'product-replacement-unavailable-product',
      eventCategory: 'Product Replacement',
      eventLabel: currentPlan?.plan_number,
    };

    return dataLayer;
  }
}
